<div class="flex justify-between items-center w-full mb-4 max-h-14 h-full bg-transparent gap-2">
    <!-- <div class="flex justify-start items-center gap-2 text-xl font-normal h-full">
        <div class="cursor-pointer" *ngIf="label!=''">
            <span [ngClass]="{'text-[#000000] text-opacity-[37%]': sub_label=='text-[#212121]', '' : sub_label!='' }" class="cursor-pointer text-xl hover:text-indigo-600">{{label}} </span><span *ngIf="sub_label != ''" class="cursor-pointer"> / {{sub_label}}</span>
        </div>
    </div> -->
    <div class="flex items-center gap-3 flex-wrap" *ngIf="breadcrumbs.length > 0">
        <ng-container *ngFor="let crumb of breadcrumbs; let i = index; let last = last">
            <!-- separator -->
            <span *ngIf="i > 0" class="text-[#A3A3A3] text-xl select-none font-medium">›</span>
            <!-- last item (current page) -->
            <span *ngIf="last" class="text-[#212121] text-xl font-medium leading-none flex items-center gap-1 relative">
                {{ crumb.label }}
                <i *ngIf="breadcrumb_dropdown_items.length > 0" (click)="toggle_breadcrumb_dropdown($event)" class='bx bx-chevron-down text-xl text-[#212121] cursor-pointer hover:text-indigo-600 transition-colors' [class.rotate-180]="breadcrumb_dropdown_open"></i>
                <!-- Dropdown -->
                <div *ngIf="breadcrumb_dropdown_open && breadcrumb_dropdown_items.length > 0" class="absolute top-8 left-0 z-50 bg-white rounded-xl shadow-xl border border-gray-100 min-w-[200px] py-1 overflow-hidden">
                    <div *ngFor="let item of breadcrumb_dropdown_items" (click)="select_breadcrumb_item(item)" class="px-4 py-2.5 text-sm text-[#212121] cursor-pointer hover:bg-indigo-50 hover:text-indigo-600 transition-colors">
                        {{ item.label }}
                    </div>
                </div>
            </span>
            <!-- parent item (clickable) -->
            <span *ngIf="!last" (click)="navigate_breadcrumb(crumb)" [class.cursor-pointer]="!!crumb.route" [class.hover:text-indigo-500]="!!crumb.route" class="text-[#A3A3A3] text-xl font-normal leading-none transition-colors duration-150 select-none" [class.cursor-default]="!crumb.route">
                {{ crumb.label }}
            </span>
        </ng-container>
    </div>
    <div class="flex justify-end items-center gap-2 pr-4">

        <!-- Messenger Icon (Evaluator / Head Evaluator only) -->
        <div *ngIf="gs.user_data?.Role?.name === 'Evaluator' || gs.user_data?.Role?.name === 'Head Evaluator'" (click)="toggle_messenger()" class="relative cursor-pointer" title="Messages">
            <div class="w-10 h-10 border border-primary rounded-lg flex justify-center items-center bg-white hover:shadow-md transition-all duration-200">
                <img src="assets/messenger.svg" alt="messages" class="w-6 h-6" />
            </div>
            <span *ngIf="chat_unread_count > 0" class="absolute -top-1.5 -right-1.5 min-w-[18px] h-[18px] px-1 flex items-center justify-center bg-red-500 text-white text-[10px] font-bold rounded-full leading-none">{{ chat_unread_count > 99 ? '99+' : chat_unread_count }}</span>
        </div>

        <!-- Notification Bell -->
        <div *ngIf="gs.user_role_data.notifications_permission || gs.user_data?.Role?.name === 'Evaluator' || gs.user_data?.Role?.name === 'Head Evaluator'" class="relative">
            <!-- Bell Button -->
            <div (click)="toggle_notifications()" class="w-10 h-10 flex justify-center items-center rounded-lg cursor-pointer hover:shadow-md relative transition-all duration-200" [ngClass]="is_notification_visible ? 'bg-[#3F41D1] shadow-md' : 'bg-white border border-[#3F41D1]'">
                <img src="../../../assets/bell 1.svg" class="w-6 h-6 transition-all duration-200" [ngClass]="is_notification_visible ? 'brightness-0 invert' : ''">
                <span *ngIf="unread_count > 0 && !is_notification_visible" class="absolute -top-1.5 -right-1.5 min-w-[18px] h-[18px] px-1 bg-red-500 rounded-full text-white text-[10px] font-medium flex items-center justify-center leading-none">
                    {{unread_count > 99 ? '99+' : unread_count}}
                </span>
            </div>

            <!-- Notification Panel -->
            <div *ngIf="is_notification_visible" class="fixed top-20 right-4 w-[400px] bg-white rounded-2xl shadow-2xl border border-gray-100 z-50 overflow-hidden">
                <div class="px-5 py-4 flex items-center justify-between">
                    <span class="text-lg font-medium text-gray-900">Notification</span>
                    <span *ngIf="unread_count > 0" class="px-3 py-1 bg-indigo-100 text-[#3F41D1] text-xs font-medium rounded-xl">
                        {{unread_count}} New
                    </span>
                </div>
                <div class="max-h-[420px] overflow-y-auto px-3 pb-3 flex flex-col gap-2">
                    <ng-container *ngIf="notifications.length > 0; else no_notifications">
                        <div *ngFor="let item of notifications" (click)="open_notification(item)" class="flex items-center gap-3 px-4 py-4 rounded-xl transition-colors" [ngClass]="(!item.is_read ? 'bg-indigo-50' : 'bg-white border border-gray-100') + (item.action_url ? ' cursor-pointer hover:bg-indigo-100' : ' cursor-default')">
                            <div class="flex-shrink-0 w-10 h-10 flex items-center justify-center">
                                <img src="../../../assets/warning-2.png" class="w-8 h-8" [style.opacity]="item.is_read ? '0.4' : '1'">
                            </div>
                            <div class="flex-1 min-w-0">
                                <p class="text-sm font-bold" [ngClass]="item.is_read ? 'text-gray-500' : 'text-gray-900'">{{ item.title || 'Notification' }}</p>
                                <p class="text-xs mt-0.5" [ngClass]="item.is_read ? 'text-gray-400' : 'text-gray-500'">{{ item.message }}</p>
                                <p class="text-xs mt-1 text-gray-400">{{ time_ago(item.createdAt) }}</p>
                            </div>
                        </div>
                    </ng-container>
                    <ng-template #no_notifications>
                        <div class="flex flex-col items-center justify-center py-10 gap-2 text-gray-400">
                            <i class="bx bx-bell-off text-3xl"></i>
                            <span class="text-xl">No notifications</span>
                        </div>
                    </ng-template>
                </div>
            </div>
        </div>

        <div *ngIf="gs.user_role_data.notifications_permission || (gs.user_data?.Role?.name === 'Evaluator' || gs.user_data?.Role?.name === 'Head Evaluator')" class="h-7 w-[2px] bg-[#D9D9D9] ml-3 rounded-full"></div>
        <!-- {{gs.user_data.image | json}} -->
        <div class="relative inline-block text-left font-sans">
            <button (click)="toggle_menu_state()" class="flex items-center gap-2 p-2 hover:bg-gray-50 rounded-lg transition-all">
                <img [src]="gs.user_data?.image || '../../../assets/Profile.svg'" class="w-10 h-10 rounded-full object-cover" alt="Profile">
                <div class="text-left">
                    <span class="text-xl font-bold text-gray-900 leading-tight">{{ gs.user_data.name || '-' }}</span>
                </div>
                <span class="material-icons text-gray-400 text-xl">expand_more</span>
            </button>

            <div *ngIf="is_dropdown_visible" class="absolute -right-3 mt-2 w-[340px] p-5 bg-white rounded-2xl shadow-xl border border-gray-200 overflow-hidden z-50">
                <!-- Top: settings | avatar + name + role | logout -->
                <div class="flex justify-between items-start">
                    <img *ngIf="gs.user_role_data.admin_configuration_view" (click)="navigate_to_settings()" src="assets/setting-2.png" alt="settings" class="w-6 h-6 cursor-pointer mt-1 opacity-100 hover:opacity-70 transition-opacity" />
                    <div *ngIf="!gs.user_role_data.admin_configuration_view"></div>
                    <div class="flex flex-col items-center gap-3">
                        <div class="relative w-24 h-24">
                            <img [src]="gs.user_data?.image || '../../../assets/Profile.svg'" class="w-24 h-24 rounded-full object-cover shadow-md" alt="Profile">
                            @if(gs.user_data.Role?.name !== 'Student') {
                            <label class="absolute inset-0 flex items-center justify-center rounded-full bg-black/40 opacity-0 hover:opacity-100 cursor-pointer transition-opacity duration-200" title="Change photo">
                                @if(is_uploading_image) {
                                <i class="bx bx-loader-alt text-white text-2xl" style="animation: spin 1s linear infinite;"></i>
                                } @else {
                                <i class="bx bx-camera text-white text-2xl"></i>
                                }
                                <input type="file" accept="image/*" class="hidden" (change)="on_profile_image_change($event)">
                            </label>
                            }
                        </div>
                        <div class="flex flex-col items-center text-center gap-0.5">
                            <span class="text-xl font-medium text-gray-900">{{ gs.user_data.name || '-' }}</span>
                            <span class="text-xl text-gray-400">{{ gs.user_data.Role?.name || '-' }}</span>
                        </div>
                    </div>
                    <img (click)="logout()" src="assets/logout.png" alt="logout" class="w-6 h-6 cursor-pointer mt-1 opacity-100 hover:opacity-70 transition-opacity" />
                </div>

                <div class="border-t border-gray-200 my-4"></div>

                <!-- Email & Phone -->
                <div class="flex flex-col gap-4">
                    <div class="flex items-center gap-3">
                        <i class='bx bx-envelope text-[#3F41D1] text-2xl flex-shrink-0'></i>
                        <span class="text-xl text-gray-500 truncate">{{ gs.user_data.email || '-' }}</span>
                    </div>
                    <div class="flex items-center gap-3">
                        <i class='bx bx-phone text-[#3F41D1] text-2xl flex-shrink-0'></i>
                        <span class="text-xl text-gray-500">{{ gs.user_data.contact ? (gs.user_data.contact.toString().length === 10 ? '+91 ' + gs.user_data.contact : gs.user_data.contact) : '-' }}</span>
                    </div>
                </div>

                @if(gs.user_data.Role?.name == 'Student'){
                <div class="flex flex-col gap-4 mt-4" style="font-size:14px; line-height:100%;">
                    <div class="grid grid-cols-[110px_20px_1fr] items-center">
                        <span class="font-medium text-[#666666]">University</span>
                        <span class="font-medium text-[#666666]">:</span>
                        <span class="text-[#666666]">{{ gs.user_data?.student_mapping?.University?.name || '-' }}</span>
                    </div>
                    <div class="grid grid-cols-[110px_20px_1fr] items-center">
                        <span class="font-medium text-[#666666]">Stream</span>
                        <span class="font-medium text-[#666666]">:</span>
                        <span class="text-[#666666]">{{ gs.user_data?.student_mapping?.Exam?.Stream?.name || '-' }}</span>
                    </div>
                    <div class="grid grid-cols-[110px_20px_1fr] items-center">
                        <span class="font-medium text-[#666666]">Program</span>
                        <span class="font-medium text-[#666666]">:</span>
                        <span class="text-[#666666]">{{ gs.user_data?.student_mapping?.Exam?.Program?.name || '-' }}</span>
                    </div>
                    <div class="grid grid-cols-[110px_20px_1fr] items-center">
                        <span class="font-medium text-[#666666]">Roll Number</span>
                        <span class="font-medium text-[#666666]">:</span>
                        <span class="text-[#666666]">{{ gs.user_data?.student_mapping?.roll_number || gs.user_data?.roll_number || '-' }}</span>
                    </div>
                    <div class="grid grid-cols-[110px_20px_1fr] items-center">
                        <span class="font-medium text-[#666666]">Registration No.</span>
                        <span class="font-medium text-[#666666]">:</span>
                        <span class="text-[#666666]">{{ gs.user_data?.registration_number || '-' }}</span>
                    </div>
                </div>
                }
            </div>
        </div>
    </div>
</div>
<!-- Messenger Panel (fixed position overlay, rendered at root level) -->
<app-messenger-panel [is_open]="is_messenger_open" (close)="is_messenger_open = false"></app-messenger-panel>

<!-- Proctor Message Modal -->
<div *ngIf="proctor_message_modal_visible" class="fixed inset-0 z-[200] flex items-center justify-center bg-black/50" (click)="close_proctor_message_modal()">
    <div class="bg-white rounded-2xl shadow-2xl w-[520px] mx-4 p-6" (click)="$event.stopPropagation()">

        <!-- Header row -->
        <div class="flex justify-between items-center mb-5">
            <h2 class="text-lg font-bold text-gray-900 tracking-wide">NEW MESSAGE</h2>
            <div class="flex items-center gap-2">
                <button (click)="close_proctor_message_modal()" class="text-gray-400 hover:text-gray-600 transition-colors text-2xl leading-none">&times;</button>
            </div>
        </div>

        <!-- Message body -->
        <div class="border border-gray-200 rounded-xl p-4 mb-5">
            <p class="text-gray-600 text-sm leading-relaxed min-h-[40px]">
                {{ proctor_message_data?.message || proctor_message_data?.meta?.message }}
            </p>
            <div class="flex justify-start items-center mt-4">
                <span class="text-gray-400 text-xs">-Admin</span>
            </div>
        </div>

        <!-- Footer -->
        <div class="flex justify-end">
            <app-button color="bg-primary text-white" (click)="acknowledge_proctor_message()" label="Ok"></app-button>
        </div>
    </div>
</div>